module.exports = __webpack_public_path__ + "pic1.jpg?5841f86525852552eb94c173a9eeff65";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/featured/pic1.jpg
// module id = 96
// module chunks = 13